import { bootstrapConsentProvider } from '@otto-ec/eprivacy-onetrust-sdk'
import {
  OnetrustCookieBanner,
  PreferenceCenterTracking,
  TrackingLabels,
  TrackingService,
} from './core'
import {
  ElementsClickObserver,
  ElementsEventObserver,
  ElementsExistsObserver,
  ElementsScrollObserver,
  ElementsVisibleObserver,
  ObserverService,
  TrackingBctAdapter,
} from './adapters'
import {
  broadcaster,
  CONSENT_CHANGED_BROADCAST_EVENT,
  featureToggles,
  initMeasureService,
  IS_APP,
  logger,
  showConsentBannerUseCase,
} from '@otto-ec/eprivacy-shared'
import {
  ElementsClickObserverPort,
  ElementsEventObserverPort,
  ElementsExistsObserverPort,
  ElementsScrollObserverPort,
  ElementsVisibleObserverPort,
  MutationObserverFactory,
  ObserverPort,
} from './ports'
import { Result } from '@otto-ec/eprivacy-measures'

declare global {
  /*                                 */
  interface Window {
    cookieBanner: OnetrustCookieBanner
    o_cookieBanner: OnetrustCookieBanner
  }
}
export const bootstrap = async () => {
  await initMeasureService.startLoad()

  const consentProvider = await bootstrapConsentProvider()
  if (!consentProvider) {
    initMeasureService.endLoad(Result.CbLoadError)
    return
  }
  const mutationObserverFactory: MutationObserverFactory = {
    create: (callback: MutationCallback) => new MutationObserver(callback),
  }
  const observerPort: ObserverPort = new ObserverService(
    mutationObserverFactory
  )

  const elementsExistsObserver: ElementsExistsObserverPort =
    new ElementsExistsObserver(document, observerPort)
  const elementsEventObserver: ElementsEventObserverPort =
    new ElementsEventObserver(document, elementsExistsObserver)
  const elementsClickObserver: ElementsClickObserverPort =
    new ElementsClickObserver(elementsEventObserver)
  const elementsScrollObserver: ElementsScrollObserverPort =
    new ElementsScrollObserver(elementsEventObserver)
  const elementsVisibleObserver: ElementsVisibleObserverPort =
    new ElementsVisibleObserver(elementsExistsObserver)

  const trackingBctAdapter = new TrackingBctAdapter<TrackingLabels>(logger)
  const trackingService = new TrackingService(
    trackingBctAdapter,
    consentProvider,
    logger,
    featureToggles
  )
  /*                                                                */
  if (!IS_APP) {
    /*                                                           */
    void trackingService.trackOTConsentDecisionPageImpression()
  }

  const pcTracking = new PreferenceCenterTracking(
    elementsVisibleObserver,
    trackingService
  )
  pcTracking.registerViewTrackingListener()

  const onetrustCookieBanner = new OnetrustCookieBanner(
    document,
    elementsClickObserver,
    elementsScrollObserver,
    elementsVisibleObserver,
    trackingService,
    initMeasureService
  )

  onetrustCookieBanner.registerEventListener()
  onetrustCookieBanner.registerLinkTrackingListener()

  const isShown = showConsentBannerUseCase.run()

  if (!IS_APP) {
    broadcaster.receive(CONSENT_CHANGED_BROADCAST_EVENT, () => {
      void showConsentBannerUseCase.hideInitial()
    })
  }

  if (!isShown || consentProvider.hasConsentBeenGiven()) {
    initMeasureService.endLoad(Result.CBHidden)
  }
}
